import { render, staticRenderFns } from "./article4.vue?vue&type=template&id=aa6b850c&scoped=true&lang=html&"
import script from "./article4.vue?vue&type=script&lang=js&"
export * from "./article4.vue?vue&type=script&lang=js&"
import style0 from "./article4.vue?vue&type=style&index=0&id=aa6b850c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b850c",
  null
  
)

export default component.exports